export default "__VITE_ASSET__Bof65uTL__"